import { AxiosError, isAxiosError } from 'axios';
import { ApiErrorResponse } from '../types/api-error-response';

export function getApiError(
  error: unknown,
  defaultMessage = 'Tivemos problemas ao realizar essa ação',
) {
  const apiError = error as AxiosError<ApiErrorResponse>;

  if (isAxiosError(error) && apiError.response?.data) {
    const response = apiError.response.data;

    if (Array.isArray(response?.message)) {
      throw new Error(
        response.message.reduce((acc: string, curr: string) => {
          const new_msg = `${acc}\n- ${curr}`;
          return new_msg;
        }),
      );
    }

    throw new Error(response.message || defaultMessage);
  }

  throw new Error(defaultMessage);
}
